module.exports = __webpack_public_path__ + "static/Medellin.6c9bd220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/Medellin.jpg
// module id = ./src/themes/Medellin.jpg
// module chunks = 35783957827783 263063586409284